export default __webpack_public_path__ + "assets/8ed2ba9a4209352383fa4eeef1107695.woff";